import type { ProviderSetupRequest } from '@epilot/sdk/phone-integration'
import { z } from 'zod'

/** Limits of phone-integration-api's ProviderSetupRequest */
const ACCOUNT_NAME_LENGTH = { min: 3, max: 100 } as const
const CLIENT_SECRET_LENGTH = { min: 12, max: 512 } as const

export const setupFormSchema = (needsAccountName: boolean) =>
  z.object({
    account_name: needsAccountName
      ? z
          .string()
          .trim()
          .min(
            ACCOUNT_NAME_LENGTH.min,
            `Enter at least ${ACCOUNT_NAME_LENGTH.min} characters.`
          )
          .max(
            ACCOUNT_NAME_LENGTH.max,
            `Use at most ${ACCOUNT_NAME_LENGTH.max} characters.`
          )
      : z.string(),
    identity_client_id: z.string().min(1, 'Select the Epilot IdP application.'),
    identity_client_secret: z
      .string()
      .min(
        CLIENT_SECRET_LENGTH.min,
        'Paste the application’s current client secret.'
      )
      .max(CLIENT_SECRET_LENGTH.max, 'This is longer than any client secret.')
  })

export type SetupFormValues = z.infer<ReturnType<typeof setupFormSchema>>

/** The account name is only sent the first time: once the tenant exists the API ignores it. */
export const toSetupRequest = (
  values: SetupFormValues,
  needsAccountName: boolean
): ProviderSetupRequest => ({
  ...(needsAccountName ? { account_name: values.account_name.trim() } : {}),
  identity_client_id: values.identity_client_id,
  identity_client_secret: values.identity_client_secret
})
